export namespace DocumentTypeStatusConstants {
  export const MISSING: string = 'Missing';
  export const PENDING: string = 'Pending';
  export const APPROVED: string = 'Approved';
  export const REJECTED: string = 'Rejected';
  export const EXPIRING: string = 'Expiring';
  export const EXPIRED: string = 'Expired';
}
